module.exports = __webpack_public_path__ + "static/media/right_bias.ed543002.png";